/**
 * Seleção para impressão em massa na lista de pedidos de venda.
 * Pura (sem React/serviços) para teste unitário. A seleção guarda os ids na ordem em que
 * foram marcados e sobrevive à troca de página: a logística junta os pedidos "Em andamento"
 * de várias páginas e imprime tudo num PDF.
 */

/** Máximo de pedidos por PDF (limite do POST /orders/pdf-batch). */
export const BATCH_PDF_MAX = 50;

export type PageSelectionState = 'none' | 'some' | 'all';

export const toggleOrderSelection = (selected: number[], orderId: number): number[] =>
  selected.includes(orderId) ? selected.filter((id) => id !== orderId) : [...selected, orderId];

export const pageSelectionState = (pageIds: number[], selected: number[]): PageSelectionState => {
  if (pageIds.length === 0) return 'none';
  const set = new Set(selected);
  const count = pageIds.filter((id) => set.has(id)).length;
  if (count === 0) return 'none';
  return count === pageIds.length ? 'all' : 'some';
};

/** Checkbox do cabeçalho: com a página toda marcada, desmarca a página; senão marca o que falta, na ordem da tela. */
export const togglePageSelection = (pageIds: number[], selected: number[]): number[] => {
  if (pageSelectionState(pageIds, selected) === 'all') {
    const page = new Set(pageIds);
    return selected.filter((id) => !page.has(id));
  }
  const set = new Set(selected);
  return [...selected, ...pageIds.filter((id) => !set.has(id))];
};

/** Quebra em lotes de até `size` (cada lote vira um PDF). */
export const chunkIds = (ids: number[], size = BATCH_PDF_MAX): number[][] => {
  const out: number[][] = [];
  for (let i = 0; i < ids.length; i += size) out.push(ids.slice(i, i + size));
  return out;
};
